import { cn } from "./classNames-DcGnTh2N.js";
import { useArgoDesign } from "./context-U293r3v-.js";
import { cva } from "class-variance-authority";
import { jsx } from "react/jsx-runtime";
import { Anchor, Close, Content, Portal, Root, Trigger } from "@radix-ui/react-popover";
//#region src/components/Popover/PopoverContent.tsx
const variants = cva([
	"tailwindcss-preflight",
	"tw:group/popover-content",
	"tw:z-[1055]",
	"tw:focus-visible:outline-hidden",
	"tw:pointer-events-auto",
	"tw:min-w-32",
	"tw:max-h-[var(--radix-popover-content-available-height)]",
	"tw:origin-(--radix-popover-content-transform-origin)",
	"tw:flex",
	"tw:flex-col",
	"tw:overflow-y-auto",
	"tw:box-border",
	"tw:border",
	"tw:border-solid",
	"tw:border-border",
	"tw:shadow-lg",
	"tw:bg-popover",
	"tw:text-popover-foreground",
	"tw:data-[state=open]:animate-in",
	"tw:data-[state=open]:fade-in-0",
	"tw:data-[state=open]:zoom-in-95",
	"tw:data-[state=closed]:animate-out",
	"tw:data-[state=closed]:fade-out-0",
	"tw:data-[state=closed]:zoom-out-95",
	"tw:data-[side=bottom]:slide-in-from-top-2",
	"tw:data-[side=left]:slide-in-from-right-2",
	"tw:data-[side=right]:slide-in-from-left-2",
	"tw:data-[side=top]:slide-in-from-bottom-2",
	"tw:[&_svg.lucide:not([class*='tw:size-'])]:size-4",
	"tw:[&_svg]:shrink-0"
], {
	defaultVariants: {
		matchTriggerWidth: false,
		variant: "default"
	},
	variants: {
		variant: {
			default: ["tw:rounded-md"],
			argo: ["tw:rounded-popover"]
		},
		matchTriggerWidth: {
			true: ["tw:w-[var(--radix-popover-trigger-width)]"],
			false: []
		}
	}
});
const PopoverContent = ({ ref, className, align = "center", sideOffset = 4, matchTriggerWidth = false, children, onEscapeKeyDown, container, ...props }) => {
	const effectiveVariant = useArgoDesign() ? "argo" : "default";
	return /* @__PURE__ */ jsx(Portal, {
		container,
		children: /* @__PURE__ */ jsx(Content, {
			ref,
			align: matchTriggerWidth ? "start" : align,
			sideOffset,
			className: cn(variants({
				className,
				matchTriggerWidth,
				variant: effectiveVariant
			})),
			onEscapeKeyDown: (event) => {
				event.stopPropagation();
				onEscapeKeyDown?.(event);
			},
			...props,
			children
		})
	});
};
//#endregion
//#region src/components/Popover/Popover.tsx
const Popover = (props) => /* @__PURE__ */ jsx(Root, { ...props });
/**
* Main Layout
*/
Popover.Content = PopoverContent;
Popover.Trigger = Trigger;
Popover.Anchor = Anchor;
Popover.Close = Close;
//#endregion
export { Popover };

//# sourceMappingURL=Popover-BU7nGOv-.js.map